import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import PhoneInput from 'react-phone-number-input'
import uniqid from 'uniqid';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';
import Loader from '../../../Loader/Loader';
import Swal from 'sweetalert2'
import { language } from './Language';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	translate,
	pattern_email,
	functionSendMail,
} from '../../../../Utils';

import Hosts, { companycode } from '../../../../Hosts';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);
	const permissions = useRef(null);

	const entities_list = useRef(null);
	const external_list = useRef(null);
	const get_epis = useRef(null);

	const document_type = useRef(null);
	const retention_time = useRef(null);
	const storage_type = useRef(null);

	const [lang, set_lang] = useState('pt');
	const [uid,] = useState(uniqid());

	const [name, setName] = useState('');
	const [profile, setProfile] = useState('');
	const [userId, setUserId] = useState(null);
	console.log('Login: ', name, profile, userId)

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)

	const [treeDataPDF, setTreeDataPDF] = useState([])
	const [treeDataEditable, setTreeDataEditable] = useState([])

	const [files_doc_pdf, set_files_doc_pdf] = useState([]);
	const [files_doc_pdf_name, set_files_doc_pdf_name] = useState([]);
	const [files_doc_editable, set_files_doc_editable] = useState([]);
	const [files_doc_editable_name, set_files_doc_editable_name] = useState([]);

	const [notify_responsable_create, set_notify_responsable_create] = useState(false)
	const [notify_responsable_aproval, set_notify_responsable_aproval] = useState(false)
	const [notify_responsable_remove, set_notify_responsable_remove] = useState(false)

	const [document_state_list, set_document_state_list] = useState([])

	const [document_state_edit, set_document_state_edit] = useState(false)
	const [document_state_aprove, set_document_state_aprove] = useState(false)
	const [document_state_remove, set_document_state_remove] = useState(false)
	const [companySearch, setCompanySearch] = useState("");

	const normalize = (str) =>
		str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() ?? '';

	const filteredCompanies = external_list.current?.filter(el =>
		normalize(el.label).includes(normalize(companySearch))
	);

	const { pathname } = useLocation()

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const fetch_entities_list = async () => {

		let res = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`)
		let result = []
		if (res.data !== undefined) {
			result = res.data.filter(el => parseInt(el.entity_type) === parseInt('1'))
		}

		return result

	}

	const fetch_external_list = async () => {

		let res = await reqGET(`${api_crud_base}/entities/special/${getTokenInfo().companycode}/Empresa`)
		let result = []
		if (res.data !== undefined) {
			result = res.data.filter(el => parseInt(el.info.entity_type) === parseInt('2'))
		}
		return result

	}

	const fetch_quality_attributes = async (type) => {

		let res = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/${type}/active`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {

				let aux = {
					id: el.id,
					name: translate(el.info.title, 'pt')
				}

				result.push(aux)
			}
		}

		return result

	}

	const fetch_intranet_quality_epi = async (type) => {

		let res = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/${type}`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {

				let aux = {
					id: el.id,
					name: translate(el.info.title, 'pt'),
					colorPrimary: el.info.color.primary,
					colorSecondary: el.info.color.secondary,
					priority: el.info.priority
				}

				result.push(aux)
			}
		}

		return result
	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}


	let get_permissions = async (e, sidebar) => {
		let handleSingleCheck = async (e, sidebar) => {
			let name = e;

			name = name.replace('_regist', '_list')

			let ver_submenu = async (node) => {
				if (node.submenu.length !== 0) {

					// node.submenu.forEach(subitem => {
					for await (let subitem of node.submenu) {

						if (subitem.path === name) {

							let aux = {}
							if (permissions.current !== null) {
								aux = permissions.current

								if (aux.create !== true) {
									aux.create = subitem.create
								}
								if (aux.edit !== true) {
									aux.edit = subitem.edit
								}
								if (aux.remove !== true) {
									aux.remove = subitem.remove
								}
							}
							else {
								aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
							}

							// set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
							set_dados(permissions.current = aux)
						}
						else {
							await ver_submenu(subitem)
						}

					}
				}
			}

			// sidebar.forEach(node => {
			for await (let node of sidebar) {
				if (node.path === name) {

					let aux = {}
					if (permissions.current !== null) {
						aux = permissions.current

						if (aux.create !== true) {
							aux.create = node.create
						}
						if (aux.edit !== true) {
							aux.edit = node.edit
						}
						if (aux.remove !== true) {
							aux.remove = node.remove
						}
					}
					else {
						aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
					}

					// set_permissions({ edit: node.edit, view: true, remove: node.remove })
					set_dados(permissions.current = aux)

					if (Array.isArray(node.submenu) && node.submenu.length > 0) {
						await ver_submenu(node)
					}

				} else
					await ver_submenu(node)
			}
		}

		await handleSingleCheck(e, sidebar)
	}

	useEffect(() => {

		(async () => {
			clean_data();

			set_lang(localStorage.getItem('lang'))

			set_dados(entities_list.current = [])
			set_dados(document_type.current = [])
			set_dados(retention_time.current = [])
			set_dados(storage_type.current = [])

			await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

			if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

				for await (let el of getTokenInfo().entity_profile) {
					await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
				}

			}

			const get_attr = async () => {

				let res_1 = await fetch_quality_attributes('doc_type')
				if (res_1.length > 0) {
					res_1 = order_array(res_1)

					let res_aux_1 = []
					for await (let el of res_1) {
						res_aux_1.push({
							id: el.id,
							label: el.name,
						})
					}
					set_dados(document_type.current = res_aux_1)
				}
				let res_2 = await fetch_quality_attributes('retention_time')
				if (res_2.length > 0) {
					res_2 = order_array(res_2)

					let res_aux_2 = []
					for await (let el of res_2) {
						res_aux_2.push({
							id: el.id,
							label: el.name,
						})
					}
					set_dados(retention_time.current = res_aux_2)
				}
				let res_3 = await fetch_quality_attributes('storage_type')
				if (res_3.length > 0) {
					res_3 = order_array(res_3)

					let res_aux_3 = []
					for await (let el of res_3) {
						res_aux_3.push({
							id: el.id,
							label: el.name
						})
					}
					set_dados(storage_type.current = res_aux_3)
				}
				let res_4 = await fetch_entities_list()
				if (res_4.length > 0) {
					res_4 = order_array(res_4)

					let res_aux_4 = []
					for await (let el of res_4) {
						res_aux_4.push({
							id: el.id,
							label: el.name,
							email: el.email
						})
					}
					set_dados(entities_list.current = res_aux_4)
				}
				let res_5 = await fetch_intranet_quality_epi('epi_type')
				if (res_5.length > 0) {
					res_5 = order_array(res_5)
					set_dados(get_epis.current = res_5)
				}
				let res_6 = await fetch_external_list()
				if (res_6.length > 0) {
					let res_aux_6 = []
					for await (let el of res_6) {
						res_aux_6.push({
							id: el.id,
							label: el.info.name,
							email: el.info.email
						})
					}
					set_dados(external_list.current = res_aux_6)
				}

				setLoading(false);

				return true

			}

			const fetch_id_info = async (id_serch) => {

				try {

					let res = await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
					set_dados(dados.current = res.data[0]);

					if (Array.isArray(res.data) && res.data.length > 0) {
						if (res.data[0]?.info?.file?.pdf !== undefined && Array.isArray(res.data[0].info.file.pdf)) {
							let aux_doc_pdf = []
							let i = 0

							for await (let el of res.data[0].info.file.pdf) {
								if (aux_doc_pdf[0] === undefined)
									aux_doc_pdf[0] = []
								if (aux_doc_pdf[0][1] === undefined)
									aux_doc_pdf[0][1] = []

								// aux_doc_pdf[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
								aux_doc_pdf[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
							}
							setTreeDataPDF(aux_doc_pdf)
						}
						if (res.data[0]?.info?.file?.editable !== undefined && Array.isArray(res.data[0].info.file.editable)) {
							let aux_doc_editable = []
							let i = 0

							for await (let el of res.data[0].info.file.editable) {
								if (aux_doc_editable[0] === undefined)
									aux_doc_editable[0] = []
								if (aux_doc_editable[0][1] === undefined)
									aux_doc_editable[0][1] = []

								// aux_doc_editable[0][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
								aux_doc_editable[0][1][0] = { id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible }
							}
							setTreeDataEditable(aux_doc_editable)
						}
					}

					set_is_edit(true)

					get_attr()

				} catch (error) {
					console.error("Erro:", error);
				}
			}
			try {
				let test = props.location.state.operation;

				if (test === 'edit') {
					await fetch_id_info(props.location.state.item.id)
				}
				else {
					await get_attr()
				}

			} catch {
				clean_data()

				await get_attr()

				return
			}

		})()

	}, [props]);

	useEffect(() => {
		const storedData = localStorage.getItem('token');
		const data = JSON.parse(storedData);
		if (storedData) {
			const data = JSON.parse(storedData);
			if (data.user_info) {
				if (data.user_info.user_info) {

				} else {

					setProfile(data.user_info.profile);
					setName(data.user_info.name);
					setUserId(data.user_info.id);

				}

			} else {
				console.log('User info nÃ£o encontrado no localStorage');
			}
		} else {
			console.log('Dados nÃ£o encontrados no localStorage');
		}
	}, []);

	const handleSubmit = async e => {
		e.preventDefault();

		let today = new Date();
		let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

		if (is_edit === true) {

			await Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						if (document_state_aprove) {
							dados.current.info.settings.document_state = "3"

							// dados.current.info.responsable.aproval.execution = today.toJSON()
							// dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = today.toJSON()
						}

						if (notify_responsable_create) {
							if (dados?.current?.info?.responsable?.create?.id !== undefined && dados.current.info.responsable.create.id !== '') {
								let aux_id = dados.current.info.responsable.create.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								// dados.current.info.responsable.edit.notification = today.toJSON()
								// dados.current.info.responsable.edit.execution = today.toJSON()

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									// dados.current.info.historic.push({
									// 	edit: {
									// 		id: aux_responsable[0].id,
									// 		name: aux_responsable[0].label,
									// 		date: today.toJSON()
									// 	},
									// 	aproval: {
									// 		id: '',
									// 		name: '',
									// 		date: ''
									// 	}
									// })

									// dados.current.info.responsable.aproval.id = ''
									// dados.current.info.responsable.aproval.name = ''
									// dados.current.info.responsable.aproval.notification = ''
									// dados.current.info.responsable.aproval.execution = ''
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										// dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										// dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
										// dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today.toJSON()
									}
									else {
										// dados.current.info.historic.push({
										// 	edit: {
										// 		id: aux_responsable[0].id,
										// 		name: aux_responsable[0].label,
										// 		date: today.toJSON()
										// 	},
										// 	aproval: {
										// 		id: '',
										// 		name: '',
										// 		date: ''
										// 	}
										// })

										dados.current.info.settings.document_state = "1"

										// dados.current.info.responsable.aproval.id = ''
										// dados.current.info.responsable.aproval.name = ''
										// dados.current.info.responsable.aproval.notification = ''
										// dados.current.info.responsable.aproval.execution = ''
									}
								}
							}
						}

						if (notify_responsable_aproval) {
							if (dados?.current?.info?.responsable?.aproval?.id !== undefined && dados.current.info.responsable.aproval.id !== '') {
								let aux_id = dados.current.info.responsable.aproval.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								// dados.current.info.responsable.aproval.notification = today.toJSON()

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
									// let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									// dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
									// dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
									// dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

								}
							}
						}

						if (notify_responsable_remove) {
							if (dados?.current?.info?.responsable?.remove?.id !== undefined && dados.current.info.responsable.remove.id !== '') {

								// dados.current.info.responsable.remove.notification = today.toJSON()
								// dados.current.info.responsable.remove.execution = today.toJSON()

							}

						}

						for await (let el_doc of files_doc_pdf) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf([])
						set_files_doc_pdf_name([])

						for await (let el_doc of files_doc_editable) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_editable([])
						set_files_doc_editable_name([])

						await reqPUT(api_crud_route, dados.current)
							.then(async () => {
								if (notify_responsable_create) {

								}
								if (notify_responsable_aproval) {
									if (dados?.current?.info?.responsable?.aproval?.id !== undefined && dados.current.info.responsable.aproval.id !== '') {

										let aux_id = dados.current.info.responsable.aproval.id
										let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										if (Array.isArray(aux_responsable) && aux_responsable.length > 0) {

											let aux = {
												id: dados.current.id,
												uniqid: dados.current.info.uniqid,
												companycode: dados.current.info.companycode,

												type: 'quality',
												title: translate(dados.current.info.title, lang),
												description: translate(dados.current.info.description, lang),
												responsaveis: [{
													value: aux_responsable[0].id
												}],
												state_object: {
													value: 1,
													labelEn: "Pending approval",
													labelPt: "Pendente de aprovação"
												},
												deadline: '',
											}

											reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

											return

											let mail_content = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + '; border:1px solid transparent; border-collapse:collapse;">' +
												'<tr style="border-collapse: collapse;">' +
												'<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<span><b>' + language[lang].notification_aproval_subject + '</b></span>' +
												'</div>' +
												'</td>' +
												'<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<span>' + today_aux + '</span>' +
												'</div>' +
												'</td>' +
												'</tr>' +

												'<tr>' +
												'<td colspan="2" align="right" style="padding: 0px 40px; height: 15px;"></td>' +
												'</tr>' +

												'<tr style="border-collapse: collapse;">' +
												'<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + '; color:' + Hosts.EMAIL_TEXT_COLOR + '">' +
												'<div>' +
												'<br/>' +
												'<span>' + language[lang].notification_aproval_text + '</span>' +
												'<br/>' +
												'</div>' +
												'</td>' +
												'</tr>' +
												'</table>'

											// let sendFrom = 'web.dev@assec.pt'
											// let sendTo = ['web.teste@assec.pt']
											// let sendToCC = ['web.dev@assec.pt']
											// let subject = language[lang].notification_aproval_subject
											// let content = mail_content
											// let attachment = []

											// await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment)
										}

									}
								}
								if (notify_responsable_remove) {
									if (dados?.current?.info?.responsable?.remove?.id !== undefined && dados.current.info.responsable.remove.id !== '') {
										// let aux_id = dados.current.info.responsable.remove.id
										// let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

										// console.log('remove aux_responsable', aux_responsable)
										// dados.current.info.responsable.remove.notification = today
									}
								}

								// props.history.push(endpoints.list) 

							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		}
		else {

			await Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then(async (result) => {
					if (result.isConfirmed) {
						dados.current.info['uniqid'] = uid
						if (document_state_aprove) {
							dados.current.info.settings.document_state = "3"

							// dados.current.info.responsable.aproval.execution = today
							// dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = today
						}

						if (notify_responsable_create) {
							if (dados?.current?.info?.responsable?.create?.id !== undefined && dados.current.info.responsable.create.id !== '') {
								let aux_id = dados.current.info.responsable.create.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								// dados.current.info.responsable.edit.notification = today
								// dados.current.info.responsable.edit.execution = today

								if (dados.current.info.historic === undefined || dados.current.info.historic === null) {
									dados.current.info.historic = []
								}

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length === 0) {
									// dados.current.info.historic.push({
									// 	edit: {
									// 		id: aux_responsable[0].id,
									// 		name: aux_responsable[0].label,
									// 		date: today
									// 	},
									// 	aproval: {
									// 		id: '',
									// 		name: '',
									// 		date: ''
									// 	}
									// })

									// dados.current.info.responsable.aproval.id = ''
									// dados.current.info.responsable.aproval.name = ''
									// dados.current.info.responsable.aproval.notification = ''
									// dados.current.info.responsable.aproval.execution = ''
								}
								else {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									if (aux?.aproval?.id === '' || (aux?.aproval?.date !== undefined && aux?.aproval?.date === '')) {
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.id = aux_responsable[0].id
										dados.current.info.historic[dados.current.info.historic.length - 1].edit.name = aux_responsable[0].label
										// dados.current.info.historic[dados.current.info.historic.length - 1].edit.date = today
									}
									else {
										// dados.current.info.historic.push({
										// 	edit: {
										// 		id: aux_responsable[0].id,
										// 		name: aux_responsable[0].label,
										// 		date: today
										// 	},
										// 	aproval: {
										// 		id: '',
										// 		name: '',
										// 		date: ''
										// 	}
										// })

										dados.current.info.settings.document_state = "1"

										// dados.current.info.responsable.aproval.id = ''
										// dados.current.info.responsable.aproval.name = ''
										// dados.current.info.responsable.aproval.notification = ''
										// dados.current.info.responsable.aproval.execution = ''
									}
								}
							}
						}

						if (notify_responsable_aproval) {
							if (dados?.current?.info?.responsable?.aproval?.id !== undefined && dados.current.info.responsable.aproval.id !== '') {
								let aux_id = dados.current.info.responsable.aproval.id
								let aux_responsable = entities_list.current.filter(e => parseInt(e.id) === parseInt(aux_id))

								// dados.current.info.responsable.aproval.notification = today

								if (Array.isArray(dados.current.info.historic) && dados.current.info.historic.length > 0) {
									let aux = dados.current.info.historic[dados.current.info.historic.length - 1]

									// dados.current.info.historic[dados.current.info.historic.length - 1].aproval.id = aux_responsable[0].id
									// dados.current.info.historic[dados.current.info.historic.length - 1].aproval.name = aux_responsable[0].label
									// dados.current.info.historic[dados.current.info.historic.length - 1].aproval.date = ''

								}
							}
						}

						if (notify_responsable_remove) {
							if (dados?.current?.info?.responsable?.aproval?.id !== undefined && dados.current.info.responsable.remove.id !== '') {

								// dados.current.info.responsable.remove.notification = today
								// dados.current.info.responsable.remove.execution = today

							}

						}

						for await (let el_doc of files_doc_pdf) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'pdf', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_pdf([])
						set_files_doc_pdf_name([])

						for await (let el_doc of files_doc_editable) {
							if (el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'editable', el_doc.langid, el_doc.lang)
							}
						}
						set_files_doc_editable([])
						set_files_doc_editable_name([])

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								// props.history.push(endpoints.list) 
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})

		}

		set_dados(dados.current,)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route, { id: dados.current.id })
						.then(() => {
							props.history.push(endpoints.list);
						})
						.catch(error => console.log(error))
				}
			})
			.catch((erro) => {
				console.log(erro)
			})

	};

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang } = dataset

		if (name === 'name' && 0) {
			let value_aux = {}
			let aux = dados.current.info.name.filter(e => e[lang])
			if (aux !== undefined && aux.length === 0) {
				value_aux[lang] = value
				dados.current.info.name.push(value_aux)
			}
			else {
				dados.current.info.name.forEach(el => {
					if (el[lang] !== undefined) {
						el[lang] = value
					}
				})
			}
		}

		set_dados(dados.current.info[name] = value)
		setRefresh(r => r + 1)

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if (dados.current.info[name] === undefined) {
			dados.current.info[name] = []
		}

		let value_aux = {}
		let aux = dados.current.info[name].filter(e => e[lang])
		if (aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.info[name].push(value_aux)
		}
		else {
			dados.current.info[name].forEach(el => {
				if (el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}

		if (name === 'title' && parseInt(langid) === 1) {
			dados.current.info.name = value
		}

		setRefresh(r => r + 1)

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvaiable = () => {
		console.log('dados.current.info', dados.current.info)
		set_dados(dados.current.info.avaiable = !dados.current.info.avaiable)
	}

	const handleSingleCheckAproval = () => {

		set_document_state_aprove(!document_state_aprove)

	}

	const change_document_settings = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.settings === undefined) {
			dados.current.info.settings = {}
		}

		set_dados(dados.current.info.settings[name] = value)

		console.log('dados.current.info.settings', dados.current.info.settings)

	}

	const change_company = (e) => {
		const { name, value } = e.target;

		if (!value) {  // 👈 guard for empty option
			dados.current.info.contacts[name] = { name: '', id: '' };
			setRefresh(r => r + 1);
			return;
		}

		const label = e.target.options[e.target.selectedIndex]?.text ?? '';

		if (!dados.current.info.contacts) {
			dados.current.info.contacts = {};
		}

		dados.current.info.contacts[name] = {
			name: label,
			id: value,
		};

		set_dados({
			...dados.current,
			info: {
				...dados.current.info,
				contacts: {
					...dados.current.info.contacts,
				},
			},
		});
	};

	const change_contacts = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.contacts === undefined) {
			dados.current.info.contacts = {}
		}

		set_dados(dados.current.info.contacts[name] = value)

		console.log('dados.current.info.contacts', dados.current.info.contacts)

	}

	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const handle_change_tree_editable = (tD, order, langid) => {

		treeDataEditable[order][langid] = tD

		let aux = []
		treeDataEditable[order][langid].forEach((el) => {
			dados.current.info.file.editable.forEach((el_2) => {
				if (el.id_doc === el_2.id)
					aux.push(el_2)
			})
		});
		set_dados(dados.current.info.file.editable = aux)
		setTreeDataEditable(treeDataEditable)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_editable = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataEditable[order][langid].filter(v => v.id !== id)
					treeDataEditable[order][langid] = treeAux
					setTreeDataEditable(treeDataEditable)

					let aux = []
					dados.current.info.file.editable.forEach((el) => {
						if (el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.info.file.editable = aux)

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_editable = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataEditable[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.info.file.editable.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataEditable(treeDataEditable)
		set_dados(dados.current.info,)
	}

	const onChangeHandlerFilesEditable = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_editable_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_editable_name(aux2)

				let aux_doc = treeDataEditable
				if (treeDataEditable[order] === undefined)
					treeDataEditable[order] = []
				if (treeDataEditable[order][langid] === undefined)
					treeDataEditable[order][langid] = []
				let i = treeDataEditable[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataEditable(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_editable
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_editable(files_aux)
	}

	const handle_change_tree_pdf = (tD, order, langid) => {

		treeDataPDF[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}
		else {
			treeDataPDF[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataPDF(treeDataPDF)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree_pdf = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataPDF[order][langid].filter(v => v.id !== id)
					treeDataPDF[order][langid] = treeAux
					setTreeDataPDF(treeDataPDF)

					let aux = []
					if (langid === '1') {
						dados.current.content[order].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order].media.doc = aux)
					}
					else {
						dados.current.content[order]['language'][langid].media.doc.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
					}

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree_pdf = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataPDF[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.content[order].media.doc.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataPDF(treeDataPDF)
		set_dados(dados.current.content[order],)
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_pdf_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_pdf_name(aux2)

				let aux_doc = treeDataPDF
				if (treeDataPDF[order] === undefined)
					treeDataPDF[order] = []
				if (treeDataPDF[order][langid] === undefined)
					treeDataPDF[order][langid] = []
				let i = treeDataPDF[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataPDF(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc_pdf
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc_pdf(files_aux)
	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		for await (let element of files) {
			aux.push(element)

			await uploadFile(element, order, type, langid, lang)
		}
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'quality')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/quality/');

		let res = await reqFILE(`${api_crud_base}/multimedia/file`, formData)

		var today_file = new Date()
		let i = Date.now()

		if (dados.current.info.file === undefined) {
			dados.current.info.file = {}
		}
		if (!Array.isArray(dados.current.info.file[type])) {
			dados.current.info.file[type] = []
		}

		if (type === 'editable') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}
		else if (type === 'pdf') {
			dados.current.info.file[type].push({
				id: i,
				link: res.data.path + '/' + res.data.name,
				name: file.name,
				description: '',
				type: type,
				date: today_file,
				order: dados.current.info.file[type].length,
				lang: []
			})
		}

		await reqPUT(api_crud_route, dados.current)

		return true

	}

	const change_document_responsable = (e, section) => {
		const { name, value } = e.target;

		if (section) {
			const draft_key = `draft_${section}`;
			if (!dados.current.info[draft_key]) dados.current.info[draft_key] = {};
			if (!dados.current.info[draft_key].responsable) dados.current.info[draft_key].responsable = {};

			const found = entities_list.current?.find(el => parseInt(el.id) === parseInt(value));
			dados.current.info[draft_key].responsable[name] = {
				id: value,
				name: found?.label ?? '',
				notification: '',
				execution: ''
			};

			setRefresh(r => r + 1);
			return;
		}

		// Original logic for main responsable
		if (!dados.current.info.responsable) dados.current.info.responsable = {};
		if (name === 'create') set_notify_responsable_create(true);
		else if (name === 'aproval') set_notify_responsable_aproval(true);
		else if (name === 'remove') set_notify_responsable_remove(true);

		const aux_entity = entities_list.current.filter(el => parseInt(el.id) === parseInt(value));
		const aux = { id: value, name: '', notification: '', execution: '' };
		if (aux_entity.length > 0) aux.name = aux_entity[0].label;

		set_dados(dados.current.info.responsable[name] = aux);
		setRefresh(r => r + 1);
	};

	const change_document_responsable_date = (e, section) => {
		const { name, value, dataset } = e.target;
		const { type } = dataset;

		const responsable_key = section ? `responsable_${section}` : 'responsable';

		if (dados.current.info[responsable_key] === undefined) {
			dados.current.info[responsable_key] = {};
		}

		if (dados.current.info[responsable_key][name] === undefined) {
			dados.current.info[responsable_key][name] = {};
		}

		set_dados(dados.current.info[responsable_key][name]['notification'] = value);
		set_dados(dados.current.info[responsable_key][name][type] = value);

		setRefresh(r => r + 1);
	};

	const add_new_edition = (section) => {
		const archive_key = `edition_archive_${section}`;
		const draft_key = `draft_${section}`;
		const epi_key = section === 'entregas' ? 'epi_entregue' : 'epi_devolvido';
		const data_key = section === 'entregas' ? 'data_entrega' : 'data_devolucao';
		const quantidade_key = section === 'entregas' ? 'quantidade_entregue' : 'quantidade_devolvida';

		if (!dados.current.info[archive_key]) {
			dados.current.info[archive_key] = [];
		}

		const draft = dados.current.info[draft_key];

		// For devoluções: calculate days difference and quantity check
		let dias_uso = null;
		let excede_prazo = false;
		let excede_quantidade = false;

		if (section === 'devolucoes') {
			if (draft.data_entrega_ref && draft[data_key]) {
				dias_uso = Math.round(
					(new Date(draft[data_key]) - new Date(draft.data_entrega_ref)) / (1000 * 60 * 60 * 24)
				);
				excede_prazo = dias_uso > 730;
			}
			if (draft.quantidade_entregue_ref !== '' && draft[quantidade_key] !== '') {
				excede_quantidade = parseFloat(draft[quantidade_key] ?? 0) > parseFloat(draft.quantidade_entregue_ref ?? 0);
			}
		}

		// Calculate expected replacement date for entregas
		let data_expectavel = '';
		if (section === 'entregas' && draft[data_key]) {
			const duracao = parseInt(draft.duracao ?? 730);
			const base = new Date(draft[data_key]);
			base.setDate(base.getDate() + duracao);
			const y = base.getFullYear();
			const m = String(base.getMonth() + 1).padStart(2, '0');
			const d = String(base.getDate()).padStart(2, '0');
			data_expectavel = `${y}-${m}-${d}`;
		}

		const aux = {
			id: Date.now(),
			[epi_key]: draft[epi_key] ? { ...draft[epi_key] } : '',
			[data_key]: draft[data_key] ?? '',
			[quantidade_key]: draft[quantidade_key] ?? '',
			responsables: {
				update: draft.responsable?.update
					? JSON.parse(JSON.stringify(draft.responsable.update))
					: {}
			},
			...(section === 'entregas' && {
				duracao: draft.duracao ?? 730,
				data_expectavel_substituicao: data_expectavel,
			}),
			...(section === 'devolucoes' && {
				epi_entregue_ref: draft.epi_entregue_ref ?? '',
				data_entrega_ref: draft.data_entrega_ref ?? '',
				quantidade_entregue_ref: draft.quantidade_entregue_ref ?? '',
				dias_uso,
				excede_prazo,
				excede_quantidade,
			}),
		};

		dados.current.info[archive_key].push(aux);

		// Reset draft
		dados.current.info[draft_key] = {
			[epi_key]: '',
			[data_key]: '',
			[quantidade_key]: '',
			...(section === 'entregas' && { duracao: 730 }),
			...(section === 'devolucoes' && {
				epi_entregue_ref: '',
				data_entrega_ref: '',
				quantidade_entregue_ref: '',
			}),
			responsable: { update: {} }
		};

		setRefresh(r => r + 1);
	};

	const edit_edition_archive = (e, section) => {
		const { name, value, dataset } = e.target;
		const { id } = dataset;
		const archive_key = `edition_archive_${section}`;

		dados.current.info[archive_key].forEach((el) => {
			if (parseInt(el.id) === parseInt(id)) {
				el[name] = value;
			}
		});

		setRefresh(r => r + 1);
	};

	// NEW: handles the epi select inside the table rows
	const edit_edition_archive_epi = (e, section) => {
		const { name, value, dataset } = e.target;
		const { id } = dataset;
		const archive_key = `edition_archive_${section}`;

		const label = e.target.options[e.target.selectedIndex].text;

		dados.current.info[archive_key].forEach((el) => {
			if (parseInt(el.id) === parseInt(id)) {
				el[name] = value ? { id: value, label } : '';
			}
		});

		setRefresh(r => r + 1);
	};

	const edit_edition_archive_responsable = (e, section) => {
		const { name, value, dataset } = e.target;
		const { id } = dataset;
		const archive_key = `edition_archive_${section}`;

		dados.current.info[archive_key].forEach((el) => {
			if (parseInt(el.id) === parseInt(id)) {
				if (el.responsables[name] === undefined) {
					el.responsables[name] = {};
				}
				el.responsables[name]['id'] = value;

				// use entities_list ref directly
				const found = entities_list.current?.find(e => parseInt(e.id) === parseInt(value));
				if (found) {
					el.responsables[name]['name'] = found.label;
				}
			}
		});

		setRefresh(r => r + 1);
	};

	const edit_edition_archive_responsable_date = (e, section) => {
		const { name, value, dataset } = e.target;
		const { id, type } = dataset;
		const archive_key = `edition_archive_${section}`;

		dados.current.info[archive_key].forEach((el) => {
			if (parseInt(el.id) === parseInt(id)) {
				if (el.responsables[name] === undefined) {
					el.responsables[name] = {};
				}
				el.responsables[name][type] = value;
			}
		});

		setRefresh(r => r + 1);
	};

	const remove_edition_archive = (id, section) => {
		const archive_key = `edition_archive_${section}`;

		dados.current.info[archive_key] = dados.current.info[archive_key].filter(
			(el) => parseInt(el.id) !== parseInt(id)
		);

		setRefresh(r => r + 1);
	};

	const format_archive_date = (dateStr) => {
		if (!dateStr) return '—';
		const clean = dateStr.split('Z')[0]; // remove Z if present
		const [datePart, timePart] = clean.split('T');
		if (!timePart) return datePart;
		const time = timePart.substring(0, 5); // HH:MM
		return `${datePart} (${time})`;
	};

	return isloading ?
		<Loader />
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<div className="container">
						<h2 className="dash-title">{language[lang].component}</h2>
						<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
					</div>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className='card'>
									<div className="card-header border-0 d-flex justify-content-sm-between d-none">
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
												{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<li key={k_lang} className="nav-item d-none">
																	<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
																</li>
															)
														})
														:
														null
												}
											</ul>
										</div>
									</div>

									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className='tab-content'>
													{
														content_language.length > 0 ?
															content_language.map((el_lang, k_lang) => {
																return (
																	<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">
																		<div className="row mb-4 d-none">
																			<div className="col-12 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].deadline}</label>
																				<input
																					type="datetime-local"
																					name="deadline"
																					data-type="execution"
																					defaultValue={dados.current.info.deadline !== undefined && dados.current.info.deadline !== null ? dados.current.info.deadline.split('Z')[0] : ''}
																					placeholder={language[lang].deadline_placeholder}
																					onChange={(e) => handle_change_info(e)}
																					className="form-control rounded-0"
																				/>
																			</div>

																			<div className="col-12 col-md-4">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].amount}</label>
																				<div className="input-group">
																					<input
																						type="text"
																						name="amount"
																						defaultValue={dados.current.info.amount !== undefined && dados.current.info.amount !== null ? dados.current.info.amount : ''}
																						placeholder={language[lang].amount_placeholder}
																						onChange={(e) => handle_change_info(e)}
																						className="form-control rounded-0 text-end"
																					/>
																					<span className='input-group-text rounded-0'>&euro;</span>
																				</div>
																			</div>
																		</div>

																		<div className="row mb-4">
																			<div className="col-12 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].company}</label>

																				<input
																					type="text"
																					placeholder={language[lang].search ?? 'Search...'}
																					value={companySearch}
																					onChange={(e) => setCompanySearch(e.target.value)}
																					className="form-control rounded-0 mb-1"
																				/>

																				<select
																					name="company"
																					className="form-select form-control mb-2 rounded-0"
																					onChange={(e) => {
																						setCompanySearch('');
																						change_company(e);
																					}}
																					value={dados?.current?.info?.contacts?.company?.id ?? ""}
																				>
																					<option value="">{language[lang].field_choose}</option>
																					{filteredCompanies?.map((el_el, k_el) => (
																						<option key={k_el} value={el_el.id}>
																							{el_el.label}
																						</option>
																					))}
																				</select>
																			</div>

																			<div className="col-12 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].createdBy}</label>
																				<select
																					name="create"
																					className="form-select form-control mb-2 rounded-0"
																					onChange={change_document_responsable}
																					value={dados?.current?.info?.responsable?.create?.id !== undefined && dados?.current?.info?.responsable?.create?.id !== null ? dados.current.info.responsable.create?.id : ''}
																				>
																					{userId && (
																						<option value={userId}>{name}</option>
																					)}

																					{
																						entities_list.current !== undefined && entities_list.current !== null ?
																							entities_list.current.map((el_el, k_el) => (
																								<option key={k_el} value={el_el.id}>
																									{el_el.label}
																								</option>
																							))
																							:
																							null
																					}
																				</select>
																			</div>
																		</div>

																		<div className="row mb-4 d-none">
																			<div className="col-12 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].data_admissao}</label>
																				<input
																					type="datetime-local"
																					name="data_admissao"
																					data-type="execution"
																					defaultValue={dados.current.info.data_admissao !== undefined && dados.current.info.data_admissao !== null ? dados.current.info.data_admissao.split('Z')[0] : ''}
																					placeholder={language[lang].data_admissao_placeholder}
																					onChange={(e) => handle_change_info(e)}
																					className="form-control rounded-0"
																				/>
																			</div>

																			<div className="col-12 col-md-4">
																				<label className="fs-6 fw-bold mb-2">{language[lang].data_demissao}</label>
																				<input
																					type="datetime-local"
																					name="data_demissao"
																					data-type="execution"
																					defaultValue={dados.current.info.data_demissao !== undefined && dados.current.info.data_demissao !== null ? dados.current.info.data_demissao.split('Z')[0] : ''}
																					placeholder={language[lang].data_demissao_placeholder}
																					onChange={(e) => handle_change_info(e)}
																					className="form-control rounded-0"
																				/>
																			</div>
																		</div>

																		<div className="row mb-4">
																			<div className="col-6 col-md-8">
																				<label className={"fs-6 fw-bold mb-2"}>{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																				<textarea type="text" rows="3" name="description" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.description, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" />
																			</div>
																		</div>
																	</div>
																)
															})
															:
															null
													}
												</div>
											</div>

											<div>
												{/* ==================== ENTREGAS ==================== */}
												<div className="card-header border-0 d-flex justify-content-sm-between">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].entregas}</h3>
													</div>
												</div>

												<div className="card-body border-top p-4">
													{permissions.current !== null && (permissions.current.create) ?
														<div className="row mb-4">

															<div className='col-12 text-end'>
																<button type="button" className="btn btn-sm btn-outline-secondary rounded-pill me-2 mb-4" onClick={() => add_new_edition('entregas')}>{language[lang].add_new_edition}</button>
															</div>

															<div className="col-6 col-md-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].epi_entregue}</label>
																<select
																	name="epi_entregue"
																	className="form-select form-control mb-4 mb-lg-0 rounded-0"
																	value={dados?.current?.info?.draft_entregas?.epi_entregue?.id ?? ''}
																	onChange={(e) => {
																		const id = e.target.value;
																		const label = e.target.options[e.target.selectedIndex].text;
																		dados.current.info.draft_entregas.epi_entregue = id ? { id, label } : '';
																		setRefresh(r => r + 1);
																	}}
																>
																	<option value="">{language[lang].field_choose}</option>
																	{get_epis?.current?.map((el, k) => <option key={k} value={el.id}>{el.name}</option>)}
																</select>
															</div>

															<div className="col-6 col-md-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].data_entrega}</label>
																<input
																	type="datetime-local"
																	name="data_entrega"
																	value={dados?.current?.info?.draft_entregas?.data_entrega ? dados.current.info.draft_entregas.data_entrega.split('Z')[0] : ''}
																	onChange={(e) => { dados.current.info.draft_entregas.data_entrega = e.target.value; setRefresh(r => r + 1); }}
																	className="form-control rounded-0"
																/>
															</div>

															<div className="col-6 col-md-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].quantidade_entregue}</label>
																<input
																	type="number"
																	name="quantidade_entregue"
																	min={0}
																	value={dados?.current?.info?.draft_entregas?.quantidade_entregue ?? ''}
																	onChange={(e) => { dados.current.info.draft_entregas.quantidade_entregue = e.target.value; setRefresh(r => r + 1); }}
																	className="form-control rounded-0"
																/>
															</div>

															<div className="col-6 col-md-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].responsavel_entrega}</label>
																<select
																	name="update"
																	className="form-select form-control mb-2 rounded-0"
																	onChange={(e) => change_document_responsable(e, 'entregas')}
																	value={dados?.current?.info?.draft_entregas?.responsable?.update?.id ?? ''}
																>
																	{userId && <option value={userId}>{name}</option>}
																	{entities_list.current?.map((el_el, k_el) => (
																		<option key={k_el} value={el_el.id}>{el_el.label}</option>
																	))}
																</select>
																{/* 
																<input
																	type="datetime-local"
																	name="update"
																	data-type="execution"
																	value={dados?.current?.info?.responsable_entregas?.update?.execution ? dados.current.info.responsable_entregas.update.execution.split('.')[0] : ''}
																	onChange={(e) => change_document_responsable_date(e, 'entregas')}
																	className="form-control rounded-0"
																/>
																*/}
															</div>
														</div>
														: null
													}

													{dados.current.info?.edition_archive_entregas !== undefined && Array.isArray(dados.current.info.edition_archive_entregas) ?
														<div className='row mt-5'>
															<div className='col-12'>
																<table className="table table-striped">
																	<thead>
																		<tr>
																			<th className='text-start'>{language[lang].epi_entregue}</th>
																			<th className='text-start'>{language[lang].data_entrega}</th>
																			<th className='text-start'>{language[lang].quantidade_entregue}</th>
																			<th className='text-start'>{language[lang].data_expectavel_substituicao}</th>
																			<th className='text-start'>{language[lang].updatedBy}</th>
																			<th className='text-start'></th>
																		</tr>
																	</thead>
																	<tbody>
																		{dados.current.info.edition_archive_entregas.map((el_ea) => (
																			<tr key={el_ea.id}>
																				<td className='text-start'>
																					{permissions.current?.create &&
																						<select name="epi_entregue" data-id={el_ea.id} className="form-select form-control rounded-0 d-none"
																							value={el_ea?.epi_entregue?.id ?? ''}
																							onChange={(e) => edit_edition_archive_epi(e, 'entregas')}>
																							<option value="">{language[lang].field_choose}</option>
																							{get_epis?.current?.map((el, k) => <option key={k} value={el.id}>{el.name}</option>)}
																						</select>
																					}
																					<span>{el_ea?.epi_entregue?.label ?? '—'}</span>
																				</td>
																				<td className='text-start'>
																					{permissions.current?.create &&
																						<input type="datetime-local" name="data_entrega" data-id={el_ea.id}
																							value={el_ea?.data_entrega ? el_ea.data_entrega.split('Z')[0] : ''}
																							onChange={(e) => edit_edition_archive(e, 'entregas')}
																							className="form-control rounded-0 d-none" />
																					}
																					<span>{el_ea?.data_entrega ? format_archive_date(el_ea.data_entrega) : '—'}</span>
																				</td>
																				<td className='text-start'>
																					{permissions.current?.create &&
																						<input type="number" name="quantidade_entregue" data-id={el_ea.id} min={0}
																							value={el_ea?.quantidade_entregue ?? ''}
																							onChange={(e) => edit_edition_archive(e, 'entregas')}
																							className="form-control rounded-0 d-none" />
																					}
																					<span>{el_ea?.quantidade_entregue ?? '—'}</span>
																				</td>
																				<td className='text-start'>
																					<span>{el_ea?.data_expectavel_substituicao ?? '—'}</span>
																				</td>
																				<td className='text-start'>
																					{permissions.current?.create &&
																						<select name="update" data-id={el_ea.id} className="form-select form-control mb-2 rounded-0 d-none"
																							onChange={(e) => edit_edition_archive_responsable(e, 'entregas')}
																							value={el_ea.responsables?.update?.id ?? ''}>
																							<option value="">{language[lang].field_choose_responsable}</option>
																							{entities_list.current?.map((el_el, k_el) => (
																								<option key={k_el} value={el_el.id}>{el_el.label}</option>
																							))}
																						</select>
																					}
																					<span>{el_ea?.responsables?.update?.name ?? '—'}</span>
																				</td>
																				<td className='text-start'>
																					{permissions.current?.create &&
																						<button type="button" className="btn btn-sm btn-outline-secondary"
																							onClick={() => remove_edition_archive(el_ea.id, 'entregas')}>
																							<i className="bi bi-trash"></i>
																						</button>
																					}
																				</td>
																			</tr>
																		))}
																	</tbody>
																</table>
															</div>
															<div className="d-flex justify-content-end mt-2">
																<span>
																	{language[lang].quantidade_entregue ?? 'Quantidade Entregue'}: {' '}
																	{dados.current.info.edition_archive_entregas.reduce((sum, el_ea) => {
																		return sum + parseFloat(el_ea?.quantidade_entregue ?? 0);
																	}, 0)}
																</span>
															</div>
														</div>
														: null
													}
												</div>

												{/* ==================== DEVOLUÇÕES ==================== */}
												<div className="card-header border-0 d-flex justify-content-sm-between">
													<div className="card-title m-0">
														<h3 className="fw-bolder m-0">{language[lang].devolucoes}</h3>
													</div>
												</div>

												<div className="card-body border-top p-4">
													{permissions.current !== null && (permissions.current.create) ?
														<div className="row mb-4">

															<div className='col-12 text-end'>
																{(() => {
																	const draft = dados.current.info.draft_devolucoes;
																	const qty_devolvida = parseFloat(draft?.quantidade_devolvida ?? 0);
																	const qty_entregue = parseFloat(draft?.quantidade_entregue_ref ?? 0);
																	const blocked = draft?.quantidade_entregue_ref !== '' &&
																		draft?.quantidade_devolvida !== '' &&
																		qty_devolvida > qty_entregue;

																	return (
																		<button
																			type="button"
																			className={"btn btn-sm rounded-pill me-2 mb-4 " + (blocked ? 'btn-outline-danger disabled' : 'btn-outline-secondary')}
																			title={blocked ? `Quantidade devolvida (${qty_devolvida}) excede a entregue (${qty_entregue})` : ''}
																			onClick={() => {
																				if (blocked) return;
																				add_new_edition('devolucoes');
																			}}
																		>
																			{language[lang].add_new_edition}
																		</button>
																	);
																})()}
															</div>

															{/* EPI select */}
															<div className="col-6 col-md-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].epi_devolvido}</label>
																<select
																	name="epi_devolvido"
																	className="form-select form-control mb-1 rounded-0"
																	value={dados?.current?.info?.draft_devolucoes?.epi_entregue_ref ?? ''}
																	onChange={(e) => {
																		const id = e.target.value;
																		const entrega = (dados.current.info.edition_archive_entregas ?? [])
																			.find(el => String(el.id) === String(id));
																		dados.current.info.draft_devolucoes.epi_entregue_ref = id;
																		dados.current.info.draft_devolucoes.epi_devolvido = entrega?.epi_entregue
																			? { ...entrega.epi_entregue }
																			: '';
																		dados.current.info.draft_devolucoes.quantidade_entregue_ref = entrega?.quantidade_entregue ?? '';
																		dados.current.info.draft_devolucoes.data_entrega_ref = entrega?.data_entrega ?? '';

																		// Lock responsável to the entrega's responsável
																		dados.current.info.draft_devolucoes.responsable = {
																			update: entrega?.responsables?.update
																				? { ...entrega.responsables.update }
																				: {}
																		};

																		setRefresh(r => r + 1);
																	}}
																>
																	<option value="">{language[lang].field_choose}</option>
																	{(dados.current.info.edition_archive_entregas ?? [])
																		.filter(el => {
																			const entregue = parseFloat(el.quantidade_entregue ?? 0);
																			const devolvido = (dados.current.info.edition_archive_devolucoes ?? [])
																				.filter(dev => String(dev.epi_entregue_ref) === String(el.id))
																				.reduce((sum, dev) => sum + parseFloat(dev.quantidade_devolvida ?? 0), 0);
																			return (entregue - devolvido) > 0;
																		})
																		.map((el, k) => (
																			<option key={k} value={el.id}>
																				{el.epi_entregue?.label ?? '—'}
																			</option>
																		))
																	}
																</select>

																{/* Quantity alert */}
																{dados.current.info.draft_devolucoes?.quantidade_entregue_ref !== '' &&
																	dados.current.info.draft_devolucoes?.quantidade_devolvida !== '' &&
																	parseFloat(dados.current.info.draft_devolucoes?.quantidade_devolvida ?? 0) > parseFloat(dados.current.info.draft_devolucoes?.quantidade_entregue_ref ?? 0) && (
																		<small className="text-danger mt-1 d-block">
																			<i className="bi bi-exclamation-triangle-fill me-1"></i>
																			{language[lang].devolucao_quantidade_excedida ?? `Quantidade excede a entregue (${dados.current.info.draft_devolucoes.quantidade_entregue_ref})`}
																		</small>
																	)
																}

																{/* Days alert */}
																{dados.current.info.draft_devolucoes?.data_entrega_ref && dados.current.info.draft_devolucoes?.data_devolucao && (() => {
																	const diff = (new Date(dados.current.info.draft_devolucoes.data_devolucao) - new Date(dados.current.info.draft_devolucoes.data_entrega_ref)) / (1000 * 60 * 60 * 24);
																	return diff > 730 ? (
																		<small className="text-danger mt-1 d-block">
																			<i className="bi bi-exclamation-triangle-fill me-1"></i>
																			{language[lang].devolucao_prazo_excedido ?? `Prazo excedido (${Math.round(diff)} dias)`}
																		</small>
																	) : (
																		<small className="text-success mt-1 d-block">
																			<i className="bi bi-check-circle-fill me-1"></i>
																			{Math.round(diff)} {language[lang].days ?? 'dias'}
																		</small>
																	);
																})()}
															</div>

															{/* Data devolução */}
															<div className="col-6 col-md-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].data_devolucao}</label>
																<input
																	type="datetime-local"
																	name="data_devolucao"
																	value={dados?.current?.info?.draft_devolucoes?.data_devolucao ? dados.current.info.draft_devolucoes.data_devolucao.split('Z')[0] : ''}
																	onChange={(e) => { dados.current.info.draft_devolucoes.data_devolucao = e.target.value; setRefresh(r => r + 1); }}
																	className="form-control rounded-0"
																/>
															</div>

															{/* Quantidade devolvida */}
															<div className="col-6 col-md-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].quantidade_devolvida}</label>
																<input
																	type="number"
																	name="quantidade_devolvida"
																	min={0}
																	value={dados?.current?.info?.draft_devolucoes?.quantidade_devolvida ?? ''}
																	onChange={(e) => { dados.current.info.draft_devolucoes.quantidade_devolvida = e.target.value; setRefresh(r => r + 1); }}
																	className="form-control rounded-0"
																/>
															</div>

															{/* Responsável — locked to entrega's responsável */}
															<div className="col-6 col-md-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].responsavel_devolucao ?? language[lang].last_update}</label>
																{dados?.current?.info?.draft_devolucoes?.epi_entregue_ref ? (
																	<div className="form-control rounded-0 bg-light">
																		<i className="bi bi-lock-fill me-2 text-muted"></i>
																		<span>{dados.current.info.draft_devolucoes?.responsable?.update?.name ?? '—'}</span>
																	</div>
																) : (
																	<div className="form-control rounded-0 bg-light text-muted">
																		<i className="bi bi-lock-fill me-2"></i>
																		{language[lang].select_epi_first ?? 'Selecione um EPI primeiro'}
																	</div>
																)}
															</div>

														</div>
														: null
													}

													{dados.current.info?.edition_archive_devolucoes !== undefined && Array.isArray(dados.current.info.edition_archive_devolucoes) ?
														<div className='row mt-5'>
															<div className='col-12'>
																<table className="table table-striped">
																	<thead>
																		<tr>
																			<th className='text-start'>{language[lang].epi_devolvido}</th>
																			<th className='text-start'>{language[lang].data_entrega}</th>
																			<th className='text-start'>{language[lang].data_devolucao}</th>
																			<th className='text-start'>{language[lang].dias_uso ?? 'Dias de Uso'}</th>
																			<th className='text-start'>{language[lang].quantidade_entregue}</th>
																			<th className='text-start'>{language[lang].quantidade_devolvida}</th>
																			<th className='text-start'>{language[lang].updatedBy}</th>
																			<th className='text-start'></th>
																		</tr>
																	</thead>
																	<tbody>
																		{dados.current.info.edition_archive_devolucoes.map((el_ea) => (
																			<tr key={el_ea.id}>
																				<td className='text-start'>
																					<span>{el_ea?.epi_devolvido?.label ?? '—'}</span>
																				</td>
																				<td className='text-start'>
																					<span>{el_ea?.data_entrega_ref ? el_ea.data_entrega_ref.split('T')[0] : '—'}</span>
																				</td>
																				<td className='text-start'>
																					<span>{el_ea?.data_devolucao ? format_archive_date(el_ea.data_devolucao) : '—'}</span>
																				</td>
																				<td className='text-start'>
																					<span className={el_ea?.excede_prazo ? 'text-danger fw-bold' : ''}>
																						{el_ea?.dias_uso !== null && el_ea?.dias_uso !== undefined ? (
																							<>
																								{el_ea.dias_uso} {language[lang].days ?? 'dias'}
																								{el_ea.excede_prazo &&
																									<i className="bi bi-exclamation-triangle-fill text-danger ms-1"></i>
																								}
																							</>
																						) : '—'}
																					</span>
																				</td>
																				<td className='text-start'>
																					<span>{el_ea?.quantidade_entregue_ref ?? '—'}</span>
																				</td>
																				<td className='text-start'>
																					<span className={el_ea?.excede_quantidade ? 'text-danger fw-bold' : ''}>
																						{el_ea?.quantidade_devolvida ?? '—'}
																						{el_ea?.excede_quantidade &&
																							<i className="bi bi-exclamation-triangle-fill text-danger ms-1"></i>
																						}
																					</span>
																				</td>
																				<td className='text-start'>
																					<span>{el_ea?.responsables?.update?.name ?? '—'}</span>
																				</td>
																				<td className='text-start'>
																					{permissions.current?.create &&
																						<button type="button" className="btn btn-sm btn-outline-secondary"
																							onClick={() => remove_edition_archive(el_ea.id, 'devolucoes')}>
																							<i className="bi bi-trash"></i>
																						</button>
																					}
																				</td>
																			</tr>
																		))}
																	</tbody>
																</table>
															</div>
															<div className="d-flex justify-content-end mt-2">
																<span>
																	{language[lang].quantidade_devolvida ?? 'Quantidade devolvida'}: {' '}
																	{dados.current.info.edition_archive_devolucoes.reduce((sum, el_ea) => {
																		return sum + parseFloat(el_ea?.quantidade_devolvida ?? 0);
																	}, 0)}
																</span>
															</div>
														</div>
														: null
													}
												</div>
											</div>

										</form>
									</div>

								</div>
							</div>

						</div>
					</div>
				</div>

				{console.log('dados.current', dados.current)}

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
